import { render } from "./SlugField.vue?vue&type=template&id=363ae52a"
import script from "./SlugField.vue?vue&type=script&lang=js"
export * from "./SlugField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SlugField.vue"]])

export default __exports__